// Advanced filter fields shared by the Login History and Login Attempts tabs,
// which both list tbl_login_attempt through /user/get-all-login-audit. Every
// key must also be in LOGIN_AUDIT_FILTER_FIELDS in the backend's
// src/api/user/controller.js, the whitelist that endpoint filters on. Types are
// documented in modules/swiftboard/components/advance-filter/advance-filter.helpers.js.
export const loginAuditFilterFields = [
  { key: "role", label: "Role", type: "enum", values: ["SUPER_ADMIN", "ADMIN", "EMPLOYEE", "CLIENT"] },
  { key: "created_date", label: "Login Time", type: "datetime", showTime: true },
];
